// @flow

import { parseContentDispositionFilename, saveFile } from "buba-components/src/utils/saveFile";
import axios from "axios";
import { downloadGuaranteeRequestDocuments } from "./inquiry";

const handleGuaranteeRequestPdfDownload = async (financingProcessId: string): Promise<void> => {
  try {
    const response = await downloadGuaranteeRequestDocuments(financingProcessId);

    const contentDisposition = response.headers["content-disposition"];
    const dateString = new Date().toLocaleDateString("de-DE", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric"
    });
    const fallbackName = contentDisposition?.includes("zip")
      ? `${dateString} Antragsdokumente.zip`
      : `${dateString} Antrag Bürgschaft.pdf`;

    return saveFile(
      response.data,
      parseContentDispositionFilename(contentDisposition) || fallbackName
    );
  } catch (err) {
    if (axios.isAxiosError(err)) {
      return console.error(err.response?.data.errors[0]);
    }

    return console.error("Downloading pdf failed", err);
  }
};

export default handleGuaranteeRequestPdfDownload;
